/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */
import { Component, ViewChild, ElementRef } from '@angular/core';
import { GtinValidationSetService } from 'app/services/gtin-validation-set.service';
import { SimpleIndefiniteProgressDialogComponent } from '../simple-indefinite-progress-dialog/simple-indefinite-progress-dialog.component';
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from "../simple-success-error-dialog-box/simple-success-error-dialog-box.component";

/** Declare $ to call bootstrap */
declare var $: any;


@Component({
  selector: 'app-gtin-dialog',
  templateUrl: './load-gtin-validation-set.dialog.component.html' 
})
export class LoadGtinValidationSetDialogComponent  {
  
  /** Progress Dialog displayed when performing actions to give the User an indication something is happening... */
  @ViewChild(SimpleIndefiniteProgressDialogComponent) indefiniteProgressDialog: SimpleIndefiniteProgressDialogComponent;

  /** File Upload UI Element */
  @ViewChild('fileTypeUpload')
  mTypeFileUploadInput: ElementRef;

  /** Reference to the SimpleSuccessErrorDialog used to display error */
  @ViewChild('successErrorDialog') 
  simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

  /** CSV File selected containing the data to be loaded as part of the GTIN Validation Set */
  csvFile: File | null = null;

  /** Name entered by the User for the GTIN Validation Set */
  name: string = '';
  addType: string = '';

  /** Holds whether the UI should be disabled or not */
  isUiDisabled = false;


  /** Constructor */
  constructor(
    private gtinService: GtinValidationSetService
  ) { }


  /**
   * Reset's the UI and displays the Dialog
   */
  public show(type: string): void {
    // Reset the UI
    this.reset();
    this.addType = type;
    // Display the Dialog
    $("#gtinDialog").modal("show");
  }

  /**
   * Hides the Dialog
   */
  public hide(): void {
    $("#gtinDialog").modal("hide");
  }

  /**
   * Called when the "Cancel" UI Button is clicked.
   * Cancels / Hides the Dialog.
   */
  onCancelClicked(): void{
    this.hide();
  }

  /**
   * Called when the File is selected.  
   */
  onTypeFileUploadChange(event: any): void {
    if (event.target.files.length === 1) {
      this.csvFile = event.target.files[0];
    }
  }

  /**
   * Called when the "Upload" Button is clicked. 
   * Calls the backend API to upload the File.
   */
  onOkClicked(): void {
    console.log(`onOkClicked() - UI Disabled=${this.isUiDisabled}`);
    if (this.csvFile != null && this.name != null && this.name.trim().length > 0) {
      if (!this.isUiDisabled) {
        this.isUiDisabled = true;
        this.indefiniteProgressDialog.show("Uploading", "Saving GTIN Validation Set...");
        this._uploadFile();
      }  
    } else {
      if (this.csvFile == null) {
        
        this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE,"Please Select a CSV File");
      } else {
        
        this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, "Please Enter The Name.");
      }
    }
  }


  onAddSetClicked(): void {
    console.log(`onAddSetClicked() - UI Disabled=${this.isUiDisabled}`);
    if ( this.name != null && this.name.trim().length > 0) {
      if (!this.isUiDisabled) {
        this.isUiDisabled = true;
        const formData = new FormData();
    //formData.append('file', this.csvFile);
    formData.append('name', this.name);
        this.gtinService.createHeaderSet(formData).then(
                        response => {
                            //$("#viewGtinDialog").modal("hide");
                            window.location.reload();
                            this.hide();

                        },
                        error => {
                            console.log("Error: " + error);
                            this.handleError(error);
                        }
                    );
      }  
    } else {
     
        this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, "Please Enter The Name.");
      
    }
  }

  /**
   * Reset's the UI Elements back to the defaults
   */
  private reset(): void {
    this.name = "";
    this.csvFile = null;
    this.isUiDisabled = false;
  }

  /** 
   * Background process used to upload / process the File.
   */
  private async _uploadFile(): Promise<void> {
    // Create the FormData used to call the API
    const formData = new FormData();
    formData.append('file', this.csvFile);
    formData.append('name', this.name);
  
    // Additional wait time used during development to simulate system load
    // await (new Promise(resolve => setTimeout(resolve, 5000)));

    try {
      await this.gtinService.uploadGtinValidationSet(formData);
    } catch (error) {
      this.indefiniteProgressDialog.hide();
      this.handleError(error);
      this.isUiDisabled = false;
      return;
    }

    this.indefiniteProgressDialog.hide();
    this.hide();
    this.reset();
    window.location.reload();
  }
  
  /**
   * Displays the error to the User
   */
  handleError(error: any): void {
    /* New handling (TJB 04/18/2023) */
    if (error?.error != null) {
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, error.error);
    } 
    
    /* Default back to old handling */
    else if (error != null) {
      const response: Response = error;
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, error.text);
    }
  }

}